import { getEnumLabel } from "@/components/news-feed/utils/filter-lookups";
import type { ShareVoiceSidebarCategory } from "@/data-access/share-of-voice/queries/shareOfVoice-sidebar-filter-queries";
import useFilterDictionary from "@/store/filter-dictionary/filter-dictionary.slice";

/**
 * Hook to get human-readable label for a specific enum value
 * Uses the filter dictionary store for lookups, falls back to prettified names
 *
 * @param category - The enum category (PROMINENCE, CATEGORY, SENTIMENT, etc.)
 * @param value - The enum value to convert
 * @returns The human-readable label, or empty string if value is null/undefined
 *
 * @example
 * ```tsx
 * const label = useEnumLabel("PROMINENCE", article.prominence);
 * // Returns "Headline" for "HEADLINE"
 * ```
 */
export const useEnumLabel = (
  category: ShareVoiceSidebarCategory,
  value: string | null | undefined,
): string => {
  const dictionaryState = useFilterDictionary();

  if (!value) return "";
  return getEnumLabel(category, value, dictionaryState);
};
